<template>
  <v-app
    :dark="darkMode"
    id="inspire"
    :class="[
      {
        'box-layout': boxLayout,
        'collapse-sidebar': collapseSidebar,
        'rtl-layout': rtlLayout,
      },
    ]"
  >
    <router-view></router-view>
    <notifications
      group="loggedIn"
      position="top right"
      animation-type="velocity"
    />
    <loading-layer></loading-layer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingLayer from "./components/Layout/LoadingLayer";
import { dayDiff } from "Helpers";

export default {
  components: {
    LoadingLayer,
  },
  data() {
    return {
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2],
        },
        leave: {
          opacity: 0,
          height: 0,
        },
      },
    };
  },
  async created() {
    this.$store.commit("loading", false);
    if (this.$store.state.auth.token) {
      const is_remember_user = localStorage.getItem("is_remember_user");
      const last_login = localStorage.getItem("last_login");
      if (!is_remember_user) return this.$store.dispatch("logoutUser");
      const time_diff = dayDiff(new Date(), new Date(last_login));
      console.log("Lần cuối cùng đăng nhập cách đây: ", time_diff);
      if (time_diff >= 2) {
        await this.$store.dispatch("refreshToken");
      } else {
        this.$store.dispatch("getAppData");
      }
    }
  },
  mounted() {
    if (
      this.selectedLocale.locale === "he" ||
      this.selectedLocale.locale === "ar"
    ) {
      this.$store.dispatch("rtlLayout");
    }
  },
  computed: {
    ...mapGetters([
      "darkMode",
      "collapseSidebar",
      "boxLayout",
      "rtlLayout",
      "selectedLocale",
    ]),
  },
};
</script>
